module.exports = __webpack_public_path__ + "static/media/backgroundQuote.f0050b7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgroundQuote.png
// module id = 236
// module chunks = 0